export default __webpack_public_path__ + "static/media/app7-bottom-bg-2.f60b9377.png";